import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Container, Row, Col } from 'reactstrap';
import MarketWheel from '../components/Desktop/MarketWheel';
import GreaterRegions from "../components/Desktop/GreaterRegions";
import GreaterRegionsMobile from "../components/Mobile/GreaterRegionsMobile";
import GenericError from "../components/Common/GenericError";
import MarketWheelMobile from '../components/Mobile/MarketWheelMobile';
import MarketsTable from '../components/Mobile/MarketsTable';
import MarketSearch from '../components/Common/MarketSearch';
import searchIcon from '../images/search-icon.svg';
import device from '../modules/mediaQuery'
import QuarterPicker from "../components/Common/QuarterPicker";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      citiesList: null,
      sectorText: '',
      position: '',
      sectorColor: '',
      isShowSearchContainer: false
    };
  }
  hideCities = () => {
    this.setState({
      citiesList: null,
      sectorText: '',
      position: '',
      sectorColor: ''
    });
  }
  displayCities = (sectorText, position, sectorColor) => {
    setTimeout(() => {
      const { marketswheel, activePeriod, selectedRegion } = this.props;
      const citiesList = marketswheel.filter((eachObject) => {
        return (eachObject.greaterRegion === selectedRegion || (selectedRegion === 'Global' && eachObject.isGlobal)) && eachObject.period === activePeriod && eachObject.position * 1 === position;
      });
      this.setState({
        citiesList,
        sectorText,
        sectorColor,
        position
      });
    }, 200)
  }

  getMarkets() {
    let sortedMarkets = [];
    this.props.markets.forEach(element => {
      if (element.market.length > 0) {
        sortedMarkets.push(element.market);
      }
    });

    return sortedMarkets.sort();
  }

  updateSVGDimensions() {
    let timeOutValue = 500;
    if (window.navigator.userAgent.indexOf('Trident') !== -1) {
      timeOutValue = 1500;
    }
    setTimeout(() => {
      const marketWheelContainer = document.querySelector('.market-wheel-desktop');
      if (!marketWheelContainer) {
        return;
      }

      let elementDetails;
      let excessHeight;
      let marketWheelDetails;

      elementDetails = document.getElementById(`Position-5-markets`).getBBox();
      excessHeight = elementDetails.height - 125;
      if (excessHeight > 0) {
        const containerDetails = '0 0 989 ' + (850 + excessHeight + 20);
        marketWheelContainer.setAttribute('viewBox', containerDetails);
      } else {
        marketWheelContainer.setAttribute('viewBox', '0 0 989 850');
      }

      elementDetails = document.getElementById(`Position-9-markets`).getBBox();
      excessHeight = elementDetails.height - 125;
      marketWheelDetails = marketWheelContainer.getAttribute('viewBox').split(' ');
      if (excessHeight > 0) {
        let heightwithSpoke = 0;
        if (document.querySelector('#Position-5-spoke').style.display === 'none') {
          heightwithSpoke = 142.5;
        }
        const containerDetails = `0 ${0 - excessHeight} 989 ${(marketWheelDetails[3] * 1) + excessHeight - heightwithSpoke + 20}`;
        marketWheelContainer.setAttribute('viewBox', containerDetails);
      } else {
        marketWheelContainer.setAttribute('viewBox', `0 ${marketWheelDetails[1]} 989 ${marketWheelDetails[3]}`);
      }
    }, timeOutValue);
  }

  onSearchClick = (isShowSearchContainer) => {
    this.setState({
      isShowSearchContainer
    });
  }

  render() {
    return (
      <Container className="main-container">
       
          <MediaQuery query={device.min.desktop}>
          <Row className="main-row">
            <Col>
            <GreaterRegions updateSVGDimensions={this.updateSVGDimensions} />
            <QuarterPicker updateSVGDimensions={this.updateSVGDimensions} />
            </Col>
            </Row>
          </MediaQuery>
        
        <MediaQuery query={device.max.tablet}>
          <div className="mobiledivregquarter">
            <Col xs="3" className="greater-regions-mobile" >
              <GreaterRegionsMobile displayCities={this.displayCities}
                sectorColor={this.state.sectorColor}
                sectorText={this.state.sectorText}
                position={this.state.position} />
                <QuarterPicker updateSVGDimensions={this.updateSVGDimensions}
                displayCities={this.displayCities}
                sectorColor={this.state.sectorColor}
                sectorText={this.state.sectorText}
                position={this.state.position} />  
            </Col>
          </div>
          <Row className="main-row">
           <MarketSearch devicetype="mobile" closeimg="false"
              marketSuggestions={this.getMarkets()}
              searchClickHandler={this.onSearchClick} /> 
          </Row>
        </MediaQuery>
        
        <Row className="market-wheel-border">
          <Col className="market-wheel">
            {this.props.currentError.Error ?
              <GenericError msg={this.props.currentError.ErrorMsg} /> :
              <>
                <MediaQuery
                  query={device.min.desktop}><MarketWheel /></MediaQuery>{/* This media query also needs to be handled to show for tablet, but not to show for larger mobile screens when they rotate to landscape */}
                <MediaQuery query={device.max.tablet}>
                  <MarketWheelMobile displayCities={this.displayCities} hideCities={this.hideCities} />
                </MediaQuery>
              </>
            }
          </Col>
        </Row>
        <MediaQuery query={device.max.tablet}>
          <MarketsTable citiesList={this.state.citiesList}
            sectorText={this.state.sectorText}
            sectorColor={this.state.sectorColor}
            position={this.state.position} />
        </MediaQuery>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentError: state.errorState,
    marketswheel: state.marketswheel,
    activePeriod: state.activePeriod,
    selectedRegion: state.greaterRegions,
    markets: state.markets
  };
};

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
